(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.contactIntakeReady === 'true') return;
      root.dataset.contactIntakeReady = 'true';

      const reason = root.querySelector('[data-contact-reason]');
      const panels = Array.from(root.querySelectorAll('[data-contact-panel]'));
      if (!reason) return;

      const update = () => {
        const selected = reason.options[reason.selectedIndex];
        const key = selected ? selected.dataset.panel : '';

        panels.forEach((panel) => {
          const active = panel.dataset.contactPanel === key;
          panel.disabled = !active;
          panel.hidden = !active;
        });
      };

      const requestedReason = new URLSearchParams(window.location.search).get('reason');
      if (requestedReason) {
        const matchingOption = Array.from(reason.options).find((option) => option.dataset.panel === requestedReason);
        if (matchingOption) reason.value = matchingOption.value;
      }

      reason.addEventListener('change', update);
      update();
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-contact-intake]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-contact-intake]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hand-tie-builder"]) return;
  try {
    
(() => {
  const palette = {
    'Black':'#151515','Red':'#df3532','Blaze Orange':'#ff6612','Purple':'#7e45c7','Pink':'#ff4f9a','Yellow':'#ffe322','Chartreuse':'#d9ff00','Blue':'#168be9','White':'#ffffff','Unpainted':'#b9c0c5','Shad':'#9aa4ab','Light Blue':'#82d1ff'
  };
  class HandTieBuilder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.form = this.closest('form');
      this.variantInput = this.querySelector('[data-variant-id]');
      this.price = this.querySelector('[data-builder-price]');
      this.preview = this.querySelector('[data-hand-tie-preview]');
      this.previewCard = this.querySelector('[data-sticky-preview]');
      this.addButton = this.form?.querySelector('[data-add-button]');
      this.addLabel = this.form?.querySelector('[data-add-label]');
      this.materialProperty = this.querySelector('[data-material-property]');
      this.silverFlashProperty = this.querySelector('[data-silver-flash-property]');
      this.materialLegend = this.querySelector('[data-material-legend]');
      this.previewMaterialLabel = this.querySelector('[data-preview-material-label]');
      this.variants = JSON.parse(this.querySelector('[data-builder-variants]')?.textContent || '[]');
      this.applyPresetFromUrl();
      this.querySelectorAll('[data-variant-option]').forEach((input) => { input.addEventListener('change', () => this.syncVariant()); });
      this.querySelectorAll('[data-color-part]').forEach((input) => { input.addEventListener('change', () => this.syncColors()); });
      this.querySelectorAll('[data-silver-flash]').forEach((input) => { input.addEventListener('change', () => this.syncFlash()); });
      this.form?.addEventListener('submit', (event) => {
        if (!this.colorsReady()) {
          event.preventDefault();
          this.syncAvailability();
        }
      });
      this.syncVariant();
      this.syncColors();
      this.syncFlash();
    }
    applyPresetFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const requested = [params.get('style'), params.get('size')].filter(Boolean);
      requested.forEach((value) => {
        const match = [...this.querySelectorAll('[data-variant-option]')].find((input) => input.value === value);
        if (match) match.checked = true;
      });
    }
    selectedOptions() {
      return [...this.querySelectorAll('[data-variant-group]')].map((group) => { return group.querySelector('[data-variant-option]:checked')?.value || ''; });
    }
    currentVariant() {
      const choices = this.selectedOptions();
      return this.variants.find((variant) => variant.options.every((value, index) => value === choices[index]));
    }
    selectedColor(part) {
      return this.querySelector('[data-color-part="' + part + '"]:checked')?.value || '';
    }
    selectedFlash() {
      return this.querySelector('[data-silver-flash]:checked')?.value || 'none';
    }
    syncVariant() {
      const variant = this.currentVariant();
      if (variant && this.variantInput) this.variantInput.value = variant.id;
      if (variant && this.price) this.price.textContent = variant.price;
      const choices = this.selectedOptions();
      const style = choices[0] || '';
      const size = choices[1] || '';
      const isMarabou = style.toLowerCase().includes('marabou');
      const materialLabel = isMarabou ? this.dataset.marabouLabel : this.dataset.hairLabel;
      const styleLabel = this.querySelector('[data-preview-style]');
      const sizeLabel = this.querySelector('[data-preview-size]');
      if (styleLabel) styleLabel.textContent = style;
      if (sizeLabel) sizeLabel.textContent = size;
      if (this.materialLegend) this.materialLegend.textContent = materialLabel;
      if (this.previewMaterialLabel) this.previewMaterialLabel.textContent = materialLabel;
      if (this.materialProperty) {
        this.materialProperty.name = isMarabou ? 'properties[Marabou Color]' : 'properties[Hair Color]';
        this.materialProperty.value = this.selectedColor('material');
      }
      this.syncAvailability();
    }
    syncColors() {
      const head = this.selectedColor('head') || 'Black';
      const body = this.selectedColor('body') || 'White';
      const material = this.selectedColor('material') || 'Chartreuse';
      if (this.previewCard) {
        this.previewCard.style.setProperty('--head-paint', palette[head] || '#151515');
        this.previewCard.style.setProperty('--body-paint', palette[body] || '#ffffff');
        this.previewCard.style.setProperty('--material-paint', palette[material] || '#d9ff00');
      }
      const headLabel = this.querySelector('[data-preview-head]');
      const bodyLabel = this.querySelector('[data-preview-body]');
      const materialLabel = this.querySelector('[data-preview-material]');
      if (headLabel) headLabel.textContent = head;
      if (bodyLabel) bodyLabel.textContent = body;
      if (materialLabel) materialLabel.textContent = material;
      if (this.materialProperty) this.materialProperty.value = this.selectedColor('material');
      this.syncAvailability();
    }
    syncFlash() {
      const enabled = this.selectedFlash() === 'silver';
      if (this.silverFlashProperty) this.silverFlashProperty.value = enabled ? 'Added' : '';
      const flashSummary = this.querySelector('[data-preview-flash-wrap]');
      if (flashSummary) flashSummary.hidden = !enabled;
    }
    colorsReady() {
      return Boolean(this.selectedColor('head') && this.selectedColor('body') && this.selectedColor('material'));
    }
    syncAvailability() {
      const variant = this.currentVariant();
      const colorsReady = this.colorsReady();
      const unavailable = variant && !variant.available;
      if (this.addButton) this.addButton.disabled = !variant || unavailable || !colorsReady;
      if (this.addLabel) {
        if (!colorsReady) this.addLabel.textContent = 'Choose your colors';
        else if (unavailable) this.addLabel.textContent = this.dataset.soldOutText;
        else this.addLabel.textContent = 'Add custom jig to cart';
      }
    }
  }
  if (!customElements.get('hand-tie-builder')) customElements.define('hand-tie-builder', HandTieBuilder);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const palette = {
    'Yellow': '#ffd21f',
    'Purple': '#8a4dff',
    'Black': '#151515',
    'White': '#ffffff',
    'Olive Yellow': '#b7b52b',
    'Lime': '#76df18',
    'Chartreuse': '#d9ff00',
    'Red': '#e43b34',
    'Orange': '#ff7a00',
    'Blue': '#168be9',
    'Snow Shine': '#f6fbff',
    'Monkey Milk': '#d6d1c7',
    'Morning Dawn': '#f29a79',
    'Bubble Gum': '#ff70ad',
    'Starry Sky Silver': '#667487'
  };

  const interferencePalette = {
    'Red': '#ef5365',
    'Blue': '#5fbfff',
    'Gold': '#e2b83f',
    'Violet': '#a777e8',
    'Green': '#68cf7b'
  };

  const tadpolePalette = { ...palette };
  const stingerPalette = { ...palette };

  const openHandTieBuilder = (button) => {
    const selector = button.closest('variant-selector');
    const size = selector?.querySelector('[data-option-index="0"] [data-option-value]:checked')?.value || '';
    const style = button.dataset.handTieStyle || 'Hair Jig';
    const url = new URL('/products/custom-hand-tie-jig-builder', window.location.origin);
    url.searchParams.set('style', style);
    if (size) url.searchParams.set('size', size);
    window.location.assign(url.pathname + url.search);
  };

  document.querySelectorAll('[data-hand-tie-builder-open]').forEach((button) => {
    button.addEventListener('click', () => openHandTieBuilder(button));

    // If an old saved URL points to a hidden Hair Jig "Custom Order" variant,
    // take the shopper straight into the real builder instead of leaving no color selected.
    const colorGroup = button.closest('[data-option-index]');
    if (colorGroup && !colorGroup.querySelector('[data-option-value]:checked')) {
      window.setTimeout(() => openHandTieBuilder(button), 0);
    }
  });

  const flakePatterns = {
    'None': { image: 'none', size: 'auto' },
    'Black': { image: 'radial-gradient(circle,rgba(8,8,8,.98) 0 1.5px,transparent 1.9px),radial-gradient(circle,rgba(50,50,50,.95) 0 1.1px,transparent 1.5px)', size: '10px 10px,13px 13px' },
    'Gold': { image: 'radial-gradient(ellipse at 20% 30%,rgba(255,218,92,.98) 0 2px,transparent 2.5px),radial-gradient(ellipse at 72% 65%,rgba(181,117,0,.98) 0 1.8px,transparent 2.3px)', size: '26px 23px,31px 27px' },
    'Silver': { image: 'radial-gradient(ellipse at 20% 30%,rgba(244,249,251,.98) 0 2px,transparent 2.5px),radial-gradient(ellipse at 72% 65%,rgba(191,205,211,.98) 0 1.8px,transparent 2.3px)', size: '26px 23px,31px 27px' },
    'Purple': { image: 'radial-gradient(ellipse at 20% 30%,rgba(181,113,255,.98) 0 2px,transparent 2.5px),radial-gradient(ellipse at 72% 65%,rgba(112,46,190,.98) 0 1.8px,transparent 2.3px)', size: '26px 23px,31px 27px' },
    'Orange': { image: 'radial-gradient(ellipse at 20% 30%,rgba(255,166,82,.98) 0 2px,transparent 2.5px),radial-gradient(ellipse at 72% 65%,rgba(221,92,0,.98) 0 1.8px,transparent 2.3px)', size: '26px 23px,31px 27px' },
    'Red': { image: 'radial-gradient(ellipse at 20% 30%,rgba(255,111,102,.98) 0 2px,transparent 2.5px),radial-gradient(ellipse at 72% 65%,rgba(182,28,28,.98) 0 1.8px,transparent 2.3px)', size: '26px 23px,31px 27px' },
    'Blue': { image: 'radial-gradient(ellipse at 20% 30%,rgba(92,178,255,.98) 0 2px,transparent 2.5px),radial-gradient(ellipse at 72% 65%,rgba(20,91,185,.98) 0 1.8px,transparent 2.3px)', size: '26px 23px,31px 27px' },
    'Green': { image: 'radial-gradient(ellipse at 20% 30%,rgba(126,235,99,.98) 0 2px,transparent 2.5px),radial-gradient(ellipse at 72% 65%,rgba(28,126,45,.98) 0 1.8px,transparent 2.3px)', size: '26px 23px,31px 27px' },
    'Pink': { image: 'radial-gradient(ellipse at 20% 30%,rgba(255,145,194,.98) 0 2px,transparent 2.5px),radial-gradient(ellipse at 72% 65%,rgba(211,52,120,.98) 0 1.8px,transparent 2.3px)', size: '26px 23px,31px 27px' },
    'Holograph Silver': { image: 'radial-gradient(ellipse at 16% 22%,rgba(255,255,255,.98) 0 1.9px,transparent 2.6px),radial-gradient(ellipse at 46% 62%,rgba(106,211,255,.92) 0 1.8px,transparent 2.5px),radial-gradient(ellipse at 78% 28%,rgba(255,130,207,.9) 0 1.8px,transparent 2.5px),radial-gradient(ellipse at 78% 78%,rgba(137,255,177,.9) 0 1.8px,transparent 2.5px),radial-gradient(ellipse at 28% 82%,rgba(221,235,255,.95) 0 1.8px,transparent 2.5px)', size: '18px 18px' }
  };

  class CustomJigBuilder extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-product-root]');
      this.form = this.closest('form');
      this.variantInput = this.root?.querySelector('[data-variant-id]');
      this.addButton = this.root?.querySelector('[data-add-to-cart]');
      this.addLabel = this.addButton?.querySelector('[data-add-label]');
      this.stickyAdd = this.root?.querySelector('[data-sticky-add]');
      this.nativeSelector = this.root?.querySelector('variant-selector');
      this.profileProperty = this.querySelector('[data-property-profile]');
      this.packSizeProperty = this.querySelector('[data-property-pack-size]');
      this.headProperty = this.querySelector('[data-property-head]');
      this.bodyProperty = this.querySelector('[data-property-body]');
      this.firstFlakeProperty = this.querySelector('[data-property-flake-first]');
      this.secondFlakeProperty = this.querySelector('[data-property-flake-second]');
      this.firstInterferenceProperty = this.querySelector('[data-property-interference-first]');
      this.secondInterferenceProperty = this.querySelector('[data-property-interference-second]');
      this.notes = this.querySelector('[data-custom-notes]');
      this.error = this.querySelector('[data-builder-error]');
      this.preview = this.querySelector('[data-jig-preview]');
      this.standalone = this.dataset.standalone === 'true';
      this.isActive = false;
      this.nativeVariantId = this.variantInput?.value || '';
      this.nativeAddDisabled = this.addButton?.disabled || false;
      this.nativeStickyDisabled = this.stickyAdd?.disabled || false;
      this.nativeAddText = this.addLabel?.textContent || 'Add to cart';
      this.nativeStickyText = this.stickyAdd?.textContent || 'Add to cart';

      this.root?.querySelectorAll('[data-custom-builder-open]').forEach((button) => {
        button.addEventListener('click', () => this.activate());
      });
      this.querySelector('[data-custom-builder-close]')?.addEventListener('click', () => this.closeBuilder());
      this.querySelectorAll('[data-custom-color]').forEach((input) => {
        input.addEventListener('change', () => this.onColorChange(input));
      });
      this.querySelectorAll('[data-custom-flake]').forEach((input) => {
        input.addEventListener('change', () => this.onFlakeChange(input));
      });
      this.querySelectorAll('[data-custom-interference]').forEach((input) => {
        input.addEventListener('change', () => this.onInterferenceChange(input));
      });
      this.querySelectorAll('[data-builder-profile]').forEach((input) => {
        input.addEventListener('change', () => this.onProfileChange(input));
      });
      this.notes?.addEventListener('input', () => this.syncValidity());
      this.form?.addEventListener('submit', (event) => this.validateSubmit(event));
      this.form?.addEventListener('formdata', (event) => this.injectSubmissionProperties(event.formData));
      this.escapeHandler = (event) => {
        if (event.key === 'Escape' && this.isActive && !this.standalone) this.closeBuilder();
      };
      document.addEventListener('keydown', this.escapeHandler);

      if (this.standalone || this.dataset.autoOpen === 'true') this.activate(true);
      else this.disableProperties();
    }

    disconnectedCallback() {
      if (this.escapeHandler) document.removeEventListener('keydown', this.escapeHandler);
      if (!this.standalone) document.body.classList.remove('custom-jig-builder-open');
    }

    enableProperties() {
      this.querySelectorAll('[data-custom-property]').forEach((input) => { input.disabled = false; });
    }

    disableProperties() {
      this.querySelectorAll('[data-custom-property]').forEach((input) => { input.disabled = true; });
    }

    activate(initial = false) {
      if (!this.standalone && !this.isActive) {
        this.nativeVariantId = this.variantInput?.value || this.nativeVariantId;
        this.nativeAddDisabled = this.addButton?.disabled || false;
        this.nativeStickyDisabled = this.stickyAdd?.disabled || false;
        this.nativeAddText = this.addLabel?.textContent || this.nativeAddText;
        this.nativeStickyText = this.stickyAdd?.textContent || this.nativeStickyText;
      }

      this.isActive = true;
      this.classList.remove('is-collapsed');
      this.root?.classList.add('is-custom-builder-active');
      if (!this.standalone) document.body.classList.add('custom-jig-builder-open');
      this.enableProperties();
      this.root?.querySelectorAll('[data-custom-builder-open]').forEach((button) => button.setAttribute('aria-expanded', 'true'));

      const selectedProfile = this.querySelector('[data-builder-profile]:checked') || this.querySelector('[data-builder-profile]');
      if (selectedProfile) {
        selectedProfile.checked = true;
        this.onProfileChange(selectedProfile);
      } else if (!this.standalone) {
        if (this.variantInput && this.dataset.builderVariantId) this.variantInput.value = this.dataset.builderVariantId;
        if (this.profileProperty) this.profileProperty.value = this.dataset.fixedProfile || '';
        this.updatePreviewProfile(this.dataset.fixedProfile || '');
      }

      this.syncValidity();
      if (!initial && window.matchMedia('(max-width: 749px)').matches) {
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    closeBuilder() {
      if (this.standalone) return;
      this.isActive = false;
      this.classList.add('is-collapsed');
      this.root?.classList.remove('is-custom-builder-active');
      document.body.classList.remove('custom-jig-builder-open');
      this.disableProperties();
      this.clearError();
      this.root?.querySelectorAll('[data-custom-builder-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));

      if (this.nativeSelector) {
        this.nativeSelector.querySelectorAll('[data-option-index]').forEach((group) => {
          if (!group.querySelector('[data-option-value]:checked')) {
            const first = group.querySelector('[data-option-value]');
            if (first) first.checked = true;
          }
        });
        if (typeof this.nativeSelector.onChange === 'function') this.nativeSelector.onChange();
      } else {
        if (this.variantInput) this.variantInput.value = this.nativeVariantId;
        if (this.addButton) this.addButton.disabled = this.nativeAddDisabled;
        if (this.stickyAdd) this.stickyAdd.disabled = this.nativeStickyDisabled;
        if (this.addLabel) this.addLabel.textContent = this.nativeAddText;
        if (this.stickyAdd) this.stickyAdd.textContent = this.nativeStickyText;
      }
    }

    packSizeForProfile(profile) {
      const normalized = (profile || '').toLowerCase();
      if (normalized.includes('stinger')) return '40ct';
      if (normalized.includes('tadpole')) return '30ct';
      return '32ct';
    }

    onProfileChange(input) {
      if (!input) return;
      if (this.variantInput) this.variantInput.value = input.dataset.builderProfileVariant || '';
      if (this.profileProperty) this.profileProperty.value = input.value;
      if (this.packSizeProperty) this.packSizeProperty.value = this.packSizeForProfile(input.value);
      this.updatePreviewProfile(input.value);
      this.syncValidity();
    }

    updatePreviewProfile(profile) {
      if (!this.preview) return;
      const normalized = profile.toLowerCase();
      let slug = 'fluke';
      if (normalized.includes('stinger')) slug = 'stinger';
      if (normalized.includes('tadpole')) slug = 'tadpole';
      this.preview.dataset.previewProfile = slug;
      const label = this.preview.querySelector('[data-preview-profile-label]');
      if (label && profile) label.textContent = profile;
      this.updateColorLabels(profile);
      this.syncPreviewColors();
      if (slug === 'tadpole') this.syncTadpoleFlakes();
      if (slug === 'stinger') this.syncStingerFlakes();
    }

    colorLabels(profile) {
      const normalized = (profile || '').toLowerCase();
      if (normalized.includes('fluke')) {
        return {
          first: 'Body Color',
          second: 'Tail Color',
          firstFlake: 'Body Flake',
          secondFlake: 'Tail Flake',
          firstInterference: 'Body Interference Color',
          secondInterference: 'Tail Interference Color'
        };
      }
      if (normalized.includes('stinger')) {
        return {
          first: 'Top Color',
          second: 'Belly Color',
          firstFlake: 'Top Flake',
          secondFlake: 'Belly Flake',
          firstInterference: 'Top Interference Color',
          secondInterference: 'Belly Interference Color'
        };
      }
      return {
        first: 'Top Color',
        second: 'Bottom Color',
        firstFlake: 'Top Flake',
        secondFlake: 'Bottom Flake',
        firstInterference: 'Top Interference Color',
        secondInterference: 'Bottom Interference Color'
      };
    }

    updateColorLabels(profile) {
      this.currentLabels = this.colorLabels(profile);
      const firstLegend = this.querySelector('[data-first-color-label]');
      const secondLegend = this.querySelector('[data-second-color-label]');
      const firstFlakeLegend = this.querySelector('[data-first-flake-label]');
      const secondFlakeLegend = this.querySelector('[data-second-flake-label]');
      if (firstLegend) firstLegend.textContent = this.currentLabels.first;
      if (secondLegend) secondLegend.textContent = this.currentLabels.second;
      if (firstFlakeLegend) firstFlakeLegend.textContent = this.currentLabels.firstFlake;
      if (secondFlakeLegend) secondFlakeLegend.textContent = this.currentLabels.secondFlake;
      if (this.headProperty) this.headProperty.name = `properties[${this.currentLabels.first}]`;
      if (this.bodyProperty) this.bodyProperty.name = `properties[${this.currentLabels.second}]`;
      if (this.firstFlakeProperty) this.firstFlakeProperty.name = `properties[${this.currentLabels.firstFlake}]`;
      if (this.secondFlakeProperty) this.secondFlakeProperty.name = `properties[${this.currentLabels.secondFlake}]`;
      if (this.firstInterferenceProperty) this.firstInterferenceProperty.name = `properties[${this.currentLabels.firstInterference}]`;
      if (this.secondInterferenceProperty) this.secondInterferenceProperty.name = `properties[${this.currentLabels.secondInterference}]`;
      const firstPreview = this.preview?.querySelector('[data-preview-head-label]');
      const secondPreview = this.preview?.querySelector('[data-preview-body-label]');
      const firstFlakePreview = this.preview?.querySelector('[data-preview-first-flake-label]');
      const secondFlakePreview = this.preview?.querySelector('[data-preview-second-flake-label]');
      const firstInterferencePreview = this.preview?.querySelector('[data-preview-first-interference-label]');
      const secondInterferencePreview = this.preview?.querySelector('[data-preview-second-interference-label]');
      if (firstPreview) firstPreview.textContent = this.headProperty?.value ? `${this.currentLabels.first}: ${this.headProperty.value}` : this.currentLabels.first;
      if (secondPreview) secondPreview.textContent = this.bodyProperty?.value ? `${this.currentLabels.second}: ${this.bodyProperty.value}` : this.currentLabels.second;
      if (firstFlakePreview) firstFlakePreview.textContent = `${this.currentLabels.firstFlake}: ${this.firstFlakeProperty?.value || 'None'}`;
      if (secondFlakePreview) secondFlakePreview.textContent = `${this.currentLabels.secondFlake}: ${this.secondFlakeProperty?.value || 'None'}`;
      if (firstInterferencePreview) firstInterferencePreview.textContent = this.currentLabels.firstInterference + ': ' + (this.firstInterferenceProperty?.value || 'None');
      if (secondInterferencePreview) secondInterferencePreview.textContent = this.currentLabels.secondInterference + ': ' + (this.secondInterferenceProperty?.value || 'None');
      this.syncFlakeLegendSwatch('first', this.firstFlakeProperty?.value || 'None');
      this.syncFlakeLegendSwatch('second', this.secondFlakeProperty?.value || 'None');
    }

    previewPaint(value) {
      const profile = this.preview?.dataset.previewProfile;
      if (profile === 'stinger') {
        return stingerPalette[value] || '#cccccc';
      }
      if (profile === 'tadpole') {
        return tadpolePalette[value] || '#cccccc';
      }
      return palette[value] || '#cccccc';
    }

    syncPreviewColors() {
      if (!this.preview) return;
      const first = this.querySelector('[data-custom-color="head"]:checked')?.value;
      const second = this.querySelector('[data-custom-color="body"]:checked')?.value;
      const firstInterference = this.querySelector('[data-custom-interference="head"]:checked')?.value || 'None';
      const secondInterference = this.querySelector('[data-custom-interference="body"]:checked')?.value || 'None';

      const syncPart = (target, color, interference) => {
        const cssVar = target === 'head' ? '--head-paint' : '--body-paint';
        const dot = this.preview.querySelector(target === 'head' ? '.jig-preview__dot--head' : '.jig-preview__dot--body');

        if (color) {
          const paint = this.previewPaint(color);
          this.preview.style.setProperty(cssVar, paint);
          if (dot) dot.style.background = paint;
        } else if (interference !== 'None') {
          const paint = interferencePalette[interference] || '#cccccc';
          this.preview.style.setProperty(cssVar, paint);
          if (dot) dot.style.background = paint;
        } else {
          this.preview.style.removeProperty(cssVar);
          if (dot) dot.style.removeProperty('background');
        }
      };

      syncPart('head', first, firstInterference);
      syncPart('body', second, secondInterference);
      this.syncInterferenceLegendSwatch('head', firstInterference);
      this.syncInterferenceLegendSwatch('body', secondInterference);
    }

    onColorChange(input) {
      const target = input.dataset.customColor;
      const value = input.value;

      if (target === 'head' || target === 'body') {
        const property = target === 'head' ? this.headProperty : this.bodyProperty;
        if (property) property.value = value;

        if (this.preview) {
          const cssVar = target === 'head' ? '--head-paint' : '--body-paint';
          this.preview.style.setProperty(cssVar, this.previewPaint(value));
          const label = this.preview.querySelector(target === 'head' ? '[data-preview-head-label]' : '[data-preview-body-label]');
          const partLabel = target === 'head' ? this.currentLabels?.first : this.currentLabels?.second;
          if (label) label.textContent = partLabel ? partLabel + ': ' + value : value;
        }
      } else if (target === 'stinger-tail') {
        // The Stinger tail keeps its interference selection when a tail color is chosen.
      }

      this.syncPreviewColors();
      this.syncValidity();
    }

    onInterferenceChange(input) {
      const target = input.dataset.customInterference;
      const value = input.value || 'None';

      const property = target === 'head' ? this.firstInterferenceProperty : (target === 'body' ? this.secondInterferenceProperty : null);
      if (property) property.value = value;

      if (target === 'head' || target === 'body') {
        const colorProperty = target === 'head' ? this.headProperty : this.bodyProperty;
        const selectedColor = colorProperty?.value || '';
        if (this.preview) {
          const cssVar = target === 'head' ? '--head-paint' : '--body-paint';
          if (selectedColor) {
            this.preview.style.setProperty(cssVar, this.previewPaint(selectedColor));
          } else if (value !== 'None') {
            this.preview.style.setProperty(cssVar, interferencePalette[value] || '#cccccc');
          } else {
            this.preview.style.removeProperty(cssVar);
          }
        }
      }

      const label = target === 'head' ? this.currentLabels?.firstInterference : this.currentLabels?.secondInterference;
      const preview = this.preview?.querySelector(target === 'head' ? '[data-preview-first-interference-label]' : '[data-preview-second-interference-label]');
      if (preview) preview.textContent = (label || 'Interference Color') + ': ' + value;
      if (target === 'head' || target === 'body') this.syncInterferenceLegendSwatch(target, value);
      this.syncPreviewColors();
      this.syncValidity();
    }
    applyTadpoleFlake(target, value) {
      const overlay = this.preview?.querySelector(`[data-tadpole-flake="${target}"]`);
      if (!overlay) return;
      if (value === 'None') {
        overlay.style.fill = 'none';
        return;
      }
      const slug = value.toLowerCase().replace(/\s+/g, '-');
      const pattern = overlay.getAttribute(`data-pattern-${slug}`);
      overlay.style.fill = pattern || 'none';
    }

    syncTadpoleFlakes() {
      if (this.preview?.dataset.previewProfile !== 'tadpole') return;
      const first = this.querySelector('[data-custom-flake="first"]:checked')?.value || 'None';
      const second = this.querySelector('[data-custom-flake="second"]:checked')?.value || 'None';
      this.applyTadpoleFlake('first', first);
      this.applyTadpoleFlake('second', second);
    }

    applyStingerFlake(target, value) {
      const overlay = this.preview?.querySelector(`[data-stinger-flake="${target}"]`);
      if (!overlay) return;
      if (value === 'None') {
        overlay.style.fill = 'none';
        return;
      }
      const slug = value.toLowerCase().replace(/\s+/g, '-');
      const pattern = overlay.getAttribute(`data-pattern-${slug}`);
      overlay.style.fill = pattern || 'none';
    }

    syncStingerFlakes() {
      if (this.preview?.dataset.previewProfile !== 'stinger') return;
      const first = this.querySelector('[data-custom-flake="first"]:checked')?.value || 'None';
      const second = this.querySelector('[data-custom-flake="second"]:checked')?.value || 'None';
      this.applyStingerFlake('first', first);
      this.applyStingerFlake('second', second);
    }

    syncFlakeLegendSwatch(target, value) {
      const swatch = this.preview?.querySelector(target === 'first' ? '[data-preview-first-flake-swatch]' : '[data-preview-second-flake-swatch]');
      if (!swatch) return;
      Array.from(swatch.classList).forEach((className) => {
        if (className.startsWith('custom-flake-chip__swatch--')) swatch.classList.remove(className);
      });
      const slug = (value || 'None').toLowerCase().replace(/\s+/g, '-');
      swatch.classList.add(`custom-flake-chip__swatch--${slug}`);
    }

    syncInterferenceLegendSwatch(target, value) {
      const swatch = this.preview?.querySelector(target === 'head' ? '[data-preview-first-interference-swatch]' : '[data-preview-second-interference-swatch]');
      if (!swatch) return;

      Array.from(swatch.classList).forEach((className) => {
        if (className.startsWith('custom-interference-chip__swatch--')) swatch.classList.remove(className);
      });

      const slug = (value || 'None').toLowerCase().replace(/\s+/g, '-');
      swatch.classList.add('custom-interference-chip__swatch--' + slug);

      const swatchPaints = {
        None: 'linear-gradient(135deg,#f6f8f6,#e7ece8)',
        Red: 'linear-gradient(135deg,#fff4f4 0%,#f05a5a 52%,#79c96b 100%)',
        Blue: 'linear-gradient(135deg,#ffffff 0%,#66c7ff 48%,#ffb26b 100%)',
        Gold: 'linear-gradient(135deg,#fff8d9 0%,#f1c64b 52%,#8c6be8 100%)',
        Violet: 'linear-gradient(135deg,#ffffff 0%,#b68cff 50%,#72d9b2 100%)',
        Green: 'linear-gradient(135deg,#ffffff 0%,#74d98a 50%,#e96b70 100%)'
      };

      swatch.style.background = swatchPaints[value] || swatchPaints.None;
    }

    onFlakeChange(input) {
      const target = input.dataset.customFlake;
      const value = input.value;
      const property = target === 'first' ? this.firstFlakeProperty : this.secondFlakeProperty;
      if (property) property.value = value;

      if (this.preview) {
        const pattern = flakePatterns[value] || flakePatterns.None;
        this.preview.style.setProperty(`--${target}-flake-pattern`, pattern.image);
        this.preview.style.setProperty(`--${target}-flake-size`, pattern.size);
        if (this.preview.dataset.previewProfile === 'tadpole') this.applyTadpoleFlake(target, value);
        if (this.preview.dataset.previewProfile === 'stinger') this.applyStingerFlake(target, value);
        const label = this.preview.querySelector(target === 'first' ? '[data-preview-first-flake-label]' : '[data-preview-second-flake-label]');
        const partLabel = target === 'first' ? this.currentLabels?.firstFlake : this.currentLabels?.secondFlake;
        if (label) label.textContent = `${partLabel || 'Flake / Glitter'}: ${value}`;
        this.syncFlakeLegendSwatch(target, value);
      }
    }

    syncSubmissionProperties() {
      if (!this.isActive) return;

      this.enableProperties();

      const selectedProfile = this.querySelector('[data-builder-profile]:checked');
      if (selectedProfile) {
        if (this.variantInput) this.variantInput.value = selectedProfile.dataset.builderProfileVariant || this.variantInput.value;
        if (this.profileProperty) this.profileProperty.value = selectedProfile.value;
        if (this.packSizeProperty) this.packSizeProperty.value = this.packSizeForProfile(selectedProfile.value);
      } else if (this.profileProperty) {
        this.profileProperty.value = this.dataset.fixedProfile || this.profileProperty.value;
        if (this.packSizeProperty) this.packSizeProperty.value = this.packSizeForProfile(this.profileProperty.value);
      }

      const firstColor = this.querySelector('[data-custom-color="head"]:checked');
      const secondColor = this.querySelector('[data-custom-color="body"]:checked');
      const firstFlake = this.querySelector('[data-custom-flake="first"]:checked');
      const secondFlake = this.querySelector('[data-custom-flake="second"]:checked');
      const firstInterference = this.querySelector('[data-custom-interference="head"]:checked');
      const secondInterference = this.querySelector('[data-custom-interference="body"]:checked');

      if (firstColor && this.headProperty) this.headProperty.value = firstColor.value;
      if (secondColor && this.bodyProperty) this.bodyProperty.value = secondColor.value;
      if (firstFlake && this.firstFlakeProperty) this.firstFlakeProperty.value = firstFlake.value;
      if (secondFlake && this.secondFlakeProperty) this.secondFlakeProperty.value = secondFlake.value;
      if (firstInterference && this.firstInterferenceProperty) this.firstInterferenceProperty.value = firstInterference.value;
      if (secondInterference && this.secondInterferenceProperty) this.secondInterferenceProperty.value = secondInterference.value;
    }

    injectSubmissionProperties(formData) {
      if (!this.isActive || !formData) return;

      this.syncSubmissionProperties();

      const profile = this.profileProperty?.value || this.querySelector('[data-builder-profile]:checked')?.value || this.dataset.fixedProfile || '';
      const packSize = this.packSizeForProfile(profile);
      const labels = this.currentLabels || this.colorLabels(profile);
      const firstColor = this.headProperty?.value || this.querySelector('[data-custom-color="head"]:checked')?.value || '';
      const secondColor = this.bodyProperty?.value || this.querySelector('[data-custom-color="body"]:checked')?.value || '';
      const firstFlake = this.firstFlakeProperty?.value || this.querySelector('[data-custom-flake="first"]:checked')?.value || 'None';
      const secondFlake = this.secondFlakeProperty?.value || this.querySelector('[data-custom-flake="second"]:checked')?.value || 'None';
      const firstInterference = this.firstInterferenceProperty?.value || this.querySelector('[data-custom-interference="head"]:checked')?.value || 'None';
      const secondInterference = this.secondInterferenceProperty?.value || this.querySelector('[data-custom-interference="body"]:checked')?.value || 'None';
      const notes = this.notes?.value.trim() || '';

      formData.set('properties[_Custom Build]', 'Yes');
      if (profile) formData.set('properties[Jig Profile]', profile);
      formData.set('properties[Pack Size]', packSize);
      if (firstColor) formData.set(`properties[${labels.first}]`, firstColor);
      if (secondColor) formData.set(`properties[${labels.second}]`, secondColor);
      formData.set(`properties[${labels.firstFlake}]`, firstFlake);
      formData.set(`properties[${labels.secondFlake}]`, secondFlake);
      formData.set(`properties[${labels.firstInterference}]`, firstInterference);
      formData.set(`properties[${labels.secondInterference}]`, secondInterference);

      if (notes) formData.set('properties[Custom Color Notes]', notes);
      else formData.delete('properties[Custom Color Notes]');

      if (labels.first !== 'Color 1') formData.delete('properties[Color 1]');
      if (labels.second !== 'Color 2') formData.delete('properties[Color 2]');
      if (labels.firstFlake !== 'Flake / Glitter 1') formData.delete('properties[Flake / Glitter 1]');
      if (labels.secondFlake !== 'Flake / Glitter 2') formData.delete('properties[Flake / Glitter 2]');
      if (labels.firstInterference !== 'Interference Color 1') formData.delete('properties[Interference Color 1]');
      if (labels.secondInterference !== 'Interference Color 2') formData.delete('properties[Interference Color 2]');
    }

    needsNotes() {
      return false;
    }

    validState() {
      const profileReady = !this.standalone || Boolean(this.querySelector('[data-builder-profile]:checked'));
      const firstInterferenceReady = Boolean(this.firstInterferenceProperty?.value && this.firstInterferenceProperty.value !== 'None');
      const secondInterferenceReady = Boolean(this.secondInterferenceProperty?.value && this.secondInterferenceProperty.value !== 'None');
      const firstReady = Boolean(this.headProperty?.value) || firstInterferenceReady;
      const secondReady = Boolean(this.bodyProperty?.value) || secondInterferenceReady;
      const colorsReady = firstReady && secondReady;
      const notesReady = !this.needsNotes() || Boolean(this.notes?.value.trim());
      return { profileReady, colorsReady, notesReady, valid: profileReady && colorsReady && notesReady };
    }

    syncValidity() {
      if (!this.isActive) return;
      const state = this.validState();
      const notesWrap = this.notes?.closest('.custom-builder-notes');
      const hint = this.querySelector('[data-notes-hint]');
      notesWrap?.classList.toggle('is-required', this.needsNotes());
      if (hint) hint.textContent = 'Optional.';

      if (this.addButton) this.addButton.disabled = !state.valid;
      if (this.stickyAdd) this.stickyAdd.disabled = !state.valid;
      let text = 'Choose your colors';
      if (state.colorsReady && !state.notesReady) text = 'Add custom color notes';
      if (state.valid) text = 'Add custom jig to cart';
      if (this.addLabel) this.addLabel.textContent = text;
      if (this.stickyAdd) this.stickyAdd.textContent = state.valid ? 'Add custom jig' : text;
      if (state.valid) this.clearError();
    }

    validateSubmit(event) {
      if (!this.isActive) return;
      this.syncSubmissionProperties();
      const state = this.validState();
      if (state.valid) return;
      event.preventDefault();
      let message = 'Choose a ' + (this.currentLabels?.first || 'Color 1') + ' and a ' + (this.currentLabels?.second || 'Color 2') + ' or their interference colors.';
      if (!state.profileReady) message = 'Choose a jig profile.';
      else if (state.colorsReady && !state.notesReady) message = 'Add your custom color notes.';
      this.showError(message);
    }

    showError(message) {
      if (!this.error) return;
      this.error.textContent = message;
      this.error.hidden = false;
      this.error.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    clearError() {
      if (!this.error) return;
      this.error.hidden = true;
      this.error.textContent = '';
    }
  }

  if (!customElements.get('custom-jig-builder')) customElements.define('custom-jig-builder', CustomJigBuilder);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.url;
        if (!url) return;

        const loadRecommendations = () => {
          fetch(url)
            .then((response) => {
              if (!response.ok) throw new Error('Recommendation request failed');
              return response.text();
            })
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const incoming = html.querySelector('product-recommendations');
              const automatic = incoming?.querySelector('[data-recommendation-source="automatic"]');

              if (automatic) {
                this.innerHTML = incoming.innerHTML;
              }
            })
            .catch(() => {});
        };

        if (!('IntersectionObserver' in window)) {
          loadRecommendations();
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          loadRecommendations();
        }, { rootMargin: '0px 0px 300px 0px' });

        observer.observe(this);
      }
    }

    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
